import { Pagination as ReactAdminPagination } from 'react-admin';

export const Pagination = (props) => <ReactAdminPagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;
